import { ReactElement } from "react";
import cx from "clsx";
import { Box } from "@twilio-paste/core/box";

import {
  Callout,
  CalloutHeading,
  CalloutText,
} from "@twilio-paste/core/callout";
import {
  CompositeCalloutProps,
  CtaButtonOptions,
} from "@twiliointernal/e2-commons-shared-definitions";
import TrackingButton from "../trackingButton";
import styles from "./compositeCallout.module.css";

/**
 * The Box container with style overrides is currently necessary due to
 * bootstrap styles coming from Console that globally override all h3 elements
 * to have a font-weight of '400'. Per Paste docs, the font-weight of a
 * CalloutHeading should be 'bold'.
 */
const CompositeCallout = ({
  ctaButtonOptions,
  description,
  element,
  heading,
  marginBottom = "space70",
  variant,
}: CompositeCalloutProps): ReactElement => (
  <Box
    as="div"
    marginBottom={marginBottom}
    className={cx(styles.calloutContainer, {
      [styles.calloutWithoutDescription]: !description,
    })}
  >
    <Callout variant={variant} element={element}>
      <Box
        as="div"
        className={cx(styles.calloutContentContainer, {
          [styles.calloutWithoutDescription]: !description,
        })}
      >
        <Box as="div">
          {heading && <CalloutHeading as="h3">{heading}</CalloutHeading>}

          {description && <CalloutText>{description}</CalloutText>}
        </Box>

        {ctaButtonOptions && (
          <Box as="div" className={styles.calloutButtonContainer}>
            {ctaButtonOptions.map((ctaButton: CtaButtonOptions, idx) => {
              const key = `${idx}-${variant}`;
              return (
                <TrackingButton
                  key={key}
                  onClick={ctaButton.onClick}
                  trackEvent={ctaButton.onTrack}
                  variant={ctaButton.variant}
                >
                  {ctaButton.children}
                </TrackingButton>
              );
            })}
          </Box>
        )}
      </Box>
    </Callout>
  </Box>
);
export default CompositeCallout;
